import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

export default function Auth() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="flex flex-col items-center">
          <h1 className="font-roboto mb-1 bg-gradient-to-r from-[#263238] via-[#004D40] via-[#00BFA5] to-[#C5E1A5] bg-clip-text text-transparent [--tw-gradient-stops:var(--tw-gradient-from)_0%,#004D40_33%,#00BFA5_66%,var(--tw-gradient-to)_100%] text-5xl font-extrabold">
            Cirkular
          </h1>
          <p className="font-opensans text-xs text-gray-600 mb-4">
            Sell.Impact.Repeat
          </p>
          <img
            src="/lovable-uploads/9f8919f3-4bdc-4066-8b22-d9788dc77ac3.png"
            alt="Cirkular Logo"
            className="w-32 h-32 mb-8"
          />
        </div>

        <Alert className="border-amber-500 bg-amber-50 [&>svg]:static [&>svg~*]:pl-0">
          <div className="flex items-center justify-center gap-2 mb-1">
            <AlertTriangle className="h-5 w-5 text-amber-600" />
            <AlertTitle className="text-amber-800 text-lg mb-0">
              Web Application Discontinued
            </AlertTitle>
          </div>
          <AlertDescription className="text-amber-700 mt-2">
            <p className="mb-4">
              The Cirkular web application is no longer available. Please
              download our mobile app for the full Cirkular experience.
            </p>
            <div className="space-y-3">
              <Button
                className="w-full bg-black hover:bg-gray-800 text-white"
                asChild
              >
                <a
                  href="https://play.google.com/store/apps/details?id=com.cirkular.world"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get it for Android
                </a>
              </Button>
              <Button
                className="w-full bg-black hover:bg-gray-800 text-white"
                asChild
              >
                <a
                  href="https://apps.apple.com/de/app/cirkular/id6756896545?l=en-GB"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Get it for iOS
                </a>
              </Button>
            </div>
          </AlertDescription>
        </Alert>
      </div>
    </div>
  );
}
